"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _BaseNotification = _interopRequireDefault(require("./BaseNotification"));

var _Icons = require("./Icons");

var _settings = require("./settings");

var _iconMap;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var iconMap = (_iconMap = {}, _defineProperty(_iconMap, _settings.NotificationType.Information, _Icons.InformationIcon), _defineProperty(_iconMap, _settings.NotificationType.Warning, _Icons.WarningIcon), _defineProperty(_iconMap, _settings.NotificationType.Error, _Icons.ErrorIcon), _defineProperty(_iconMap, _settings.NotificationType.Success, _Icons.SuccessIcon), _iconMap);
/**
 * Notification component
 */

var Notification = function Notification(_ref) {
  var className = _ref.className,
      type = _ref.type,
      icon = _ref.icon,
      size = _ref.size,
      align = _ref.align,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "type", "icon", "size", "align", "children"]);

  var Icon = iconMap[type];
  var styles = (0, _classnames.default)(className, {
    '-icon': icon,
    '-small': size === 'small'
  });
  var flexStyles = (0, _classnames.default)('media-flex media-flex--small media-flex--center', _defineProperty({}, "media-flex--".concat(align), !!align));
  return _react.default.createElement(_BaseNotification.default, _extends({
    className: styles,
    type: type
  }, props), _react.default.createElement("div", {
    className: flexStyles,
    "data-notification-wrapper": true
  }, icon && Icon && _react.default.createElement(Icon, {
    className: "media-flex__img"
  }), _react.default.createElement("div", {
    className: "media-flex__body"
  }, children)));
};

Notification.defaultProps = {
  icon: true,
  size: 'medium'
};
Notification.propTypes = _objectSpread({}, _BaseNotification.default.propTypes, {
  /**
   * Determines whether an icon should be visible or not
   */
  icon: _propTypes.default.bool,

  /**
   * Change the size of the notification
   */
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),

  /**
   * Change the alignment of components inside the notification
   */
  align: _propTypes.default.oneOf(['center', 'bottom'])
});
var _default = Notification;
exports.default = _default;